export default __webpack_public_path__ + "static/B0101-9a7322a39b88fdef06103b9d2744521e.png";